import { render } from "./RewardsCardPreview.vue?vue&type=template&id=5389009e&scoped=true"
import script from "./RewardsCardPreview.vue?vue&type=script&lang=js"
export * from "./RewardsCardPreview.vue?vue&type=script&lang=js"

import "./RewardsCardPreview.vue?vue&type=style&index=0&id=5389009e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5389009e"]])

export default __exports__